import { Divider } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Loan } from '/src/lib/models';

export type RatesAndFeesProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Loan to display rates and fees for
   */
  loan?: Loan;
};

export const RatesAndFees: React.FC<RatesAndFeesProps> = ({ loan, open, toggleOpen }) => (
  <SidebarItem title="Rates & Fees" open={open} toggleOpen={toggleOpen} resolved={!!loan}>
    <InfoItem title="Advance Rate" value={loan?.advanceRate} percent smallFont />
    <Divider />
    {!loan?.isOwned ? (
      <>
        <InfoItem title="Interest Rate" value={loan?.interestRate} percent smallFont />
        <Divider />
        <InfoItem title="Origination Fee" value={loan?.originationFee} percent smallFont />
        <Divider />
        {!!loan?.adminFee && <InfoItem title="Administrative Fee" value={loan.adminFee} percent smallFont />}
        <Divider />
        {!!loan?.discountFee && <InfoItem title="Discount Fee" value={loan.discountFee} percent smallFont />}
      </>
    ) : (
      <>
        <InfoItem title="Administrative Fee" value={loan?.adminFee} percent smallFont />
        <Divider />
        <InfoItem title="Discount Fee" value={loan?.discountFee} percent smallFont />
      </>
    )}
  </SidebarItem>
);
